import React from 'react'
import styled from '@emotion/styled'
import { Container } from 'components/layout/Container/Container'
import DebtConsolidationCalculator from '../DebtConsolidation'
import { BasicCrossSell } from 'components/layout'
import { FionaTopics } from 'parameters/general'
import { colors, mediaQueriesByDevice, ROUTES } from 'parameters/index'
import { ArticleSummary } from 'services/ContentfulService/models/articles'
import { ArticleSection } from 'experiences/shared/ArticleSection'
import { Topic } from 'services/ContentfulService/models/topics'
import { TopicsSection } from 'experiences/learn/topics/TopicsSection'
import Link from 'next/link'
import { truncArray } from 'lib'
import { DebtConsolidationMan } from 'experiences/learn/topics/CalculatorPreviewTile/graphic'

interface Props {
	topics: Topic[]
	articles: ArticleSummary[]
}

export const DedicatedDebtCalculatorPage: React.FC<React.PropsWithChildren<Props>> = ({ topics, articles }) => {
	return (
		<OuterWrapper>
			<Purple></Purple>
			<Container>
				<Top>
					<Title>Debt Consolidation Calculator</Title>
					<Text>
						See how much you could save by estimating your combined debt and average interest rate. It&apos;s fast,easy
						and free. With no risk to your credit. For personalized offers,&nbsp;
						<Link href={ROUTES.SEARCH}>start a new search.</Link>
					</Text>
				</Top>
				<Content>
					<CalculatorWrapper>
						<ImageWrapper>{DebtConsolidationMan}</ImageWrapper>
						<DebtConsolidationCalculator isExpanded showTitle={false} />
					</CalculatorWrapper>
					<BasicCrossSell product={FionaTopics.DebtConsolidation} />
				</Content>
				<ContentWrapper>
					<TopicsSection title="Related Topics" topics={topics} linkTo={ROUTES.LEARN_TOPICS} />
				</ContentWrapper>
				<ContentWrapper>
					<ArticleSection
						title="Related Articles"
						articles={truncArray(articles, 4)}
						linkTo={ROUTES.LEARN_ARTICLES}
						isSmallCard
					/>
				</ContentWrapper>
			</Container>
		</OuterWrapper>
	)
}

const OuterWrapper = styled.div`
	position: relative;
`

const Purple = styled.div`
	position: absolute;
	background-color: ${colors.secondaryPurple2};
	width: 100%;
	height: 242px;
	z-index: -10;
	${mediaQueriesByDevice.mobile} {
		height: 380px;
	}
`

const ImageWrapper = styled.div`
	width: 266px;
	position: absolute;
	right: -223px;
	top: -156px;
	z-index: -10;
	svg {
		width: 100%;
	}
	${mediaQueriesByDevice.tablet} {
		display: none;
	}
`

const Title = styled.h2`
	margin: 28px 0 8px 0;
	${mediaQueriesByDevice.mobile} {
		margin: 8px 0 8px 0;
	}
`

const CalculatorWrapper = styled.div`
	position: relative;
	background-color: ${colors.white};
	box-shadow: 0px 0px 16px rgba(0, 0, 0, 0.08);
	border-radius: 8px;
	margin-bottom: 96px;
	${mediaQueriesByDevice.mobile} {
		width: 100%;
		margin: 0 auto;
	}
	${mediaQueriesByDevice.tablet} {
		margin-bottom: 48px;
	}
`

const Top = styled.div`
	display: flex;
	flex-direction: column;
	margin: 0 auto;
	margin-bottom: 32px;
	max-width: 1000px;
`

const Text = styled.span`
	font-size: 18px;
	width: 80%;
	a {
		color: ${colors.secondaryPurple1};
	}
	${mediaQueriesByDevice.tablet} {
		width: 100%;
	}
`

const Content = styled.div`
	max-width: 635px;
	margin: 0 auto;
	margin-bottom: 84px;
`

const ContentWrapper = styled.div`
	margin-bottom: 64px;
`
